import { filter, find, includes, isEmpty, propEq } from 'ramda';
import store from '../../redux/Store';
import '../../i18n';
import { getTranslation } from '../../Components/Graphs/sensor-utils';

const regex = /\(.*\)/;

const checkPathName = (pathName: string, pathId: string) => {
  const getPaths = () => {
    const state = store.getState();
    if (!state.project.loadedProject) return;
    const { paths } = state.project.loadedProject;
    return paths;
  };

  let _paths = getPaths();
  if (!_paths) return;
  if (pathId) {
    _paths = filter((p) => p.id !== pathId, _paths);
  }

  const getDefaultPathName = () => {
    const untitledPath = getTranslation('pathCreationDialog.untitled_path', 'Untitled Path');
    return untitledPath;
  };

  const checkPathNameNumber = (count: number, testName: string) => {
    const testTitle = `${testName} (${count})`;
    const found = find(propEq(testTitle, 'name'), _paths);
    if (found) return checkPathNameNumber(count + 1, testName);
    return testTitle;
  };

  const findMatch = (title: string, count: number) => {
    let _count = count;
    let testName = pathName;
    if (isEmpty(testName)) testName = getDefaultPathName();
    const match = title.match(regex);
    let oldTitle = title;
    if (match) {
      oldTitle = title.replace(regex, '');
    }
    if (oldTitle.trim() === testName.trim()) _count += 1;
    return _count;
  };

  /**
   * Checks the name of a path to make sure it doesn't match the name of an existing program
   * the user already has. Most common scenario is the user never names paths so they have a bunch of
   * Untitled Paths.
   * @param {*array} data an array of paths for the projecy
   * @param {*string} pathName the name of the path.
   * @returns
   */
  const checkTitle = () => {
    let count = 0;
    let testName = pathName.trim();
    if (isEmpty(testName)) testName = getDefaultPathName();
    const containsName = filter((path) => includes(testName, path.name), _paths);
    if (containsName.length > 0) {
      // first look for exact matches
      containsName.forEach((path) => {
        if (path.name === testName && path.name.match(regex)) testName = `${testName} (1)`;
      });
      containsName.forEach((path) => {
        if (path.name) {
          count = findMatch(path.name, count);
        } else {
          const title = getDefaultPathName();
          count = findMatch(title, count);
        }
      });
      if (count === 0) return testName;
      const checkedName = checkPathNameNumber(count, testName);
      return checkedName;
    }
    return testName;
  };

  return checkTitle();
};

export default checkPathName;
